export default __webpack_public_path__ + "static/media/10m-light.cad3acca.svg";